const namespace = 'BOOKING/';

export const PREVIOUS_BOOKING = `${namespace}PREVIOUS_BOOKING`;
export const DELETE_PREVIOUS_BOOKING = `${namespace}DELETE_PREVIOUS_BOOKING`;
